module.exports = __webpack_public_path__ + "static/media/elemento_body_2.230f0000.svg";